
// https://ssl.captcha.qq.com/TCaptcha.js
import $ from 'jquery'
 const auth = (fn) => {
    try {
        var captcha = new TencentCaptcha('69f76d314a314e9bbc9a98cd67ff3f5d', (res)=>callback(res,fn), {});
        captcha.show();
    } catch (error) {
        loadErrorCallback();
    }
}

const loadErrorCallback = () => {
    var appid = ''
// 生成容灾票据或自行做其它处理
    var ticket = 'terror_1001_' + appid + Math.floor(new Date().getTime() / 1000);
    callback({
        ret: 0,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error',
    });
    $(".submit_btn").attr("disabled", false);
}

const callback = (res,fn) => {
    const {randstr, ticket} = res;
    if(randstr&&ticket){
        remoteAuth(randstr, ticket,fn)
    }else{
        $(".submit_btn").attr("disabled", false);
    }
}

// 后端验证
const remoteAuth = (randstr, ticket,fn) => {
    const request = {
        randStr:randstr, Ticket:ticket
    }
    fetch('https://gateway.system.realmerit.com.cn/release/offical/api/website/Captcha', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request) // body data type must match "Content-Type"
    }).then(async (response) => {
        try {
            const result = await response.json()
            // code = 1 是错误 或者statusCode 不是200为错误
            if (result.code === 1 || (result.statusCode && result.statusCode !== 200)) {
                return alert('提交失败')
            }
            fn&&fn(request)
        } catch (e) {
            throw Error(e)
        }
    }).catch((error) => {
        console.error(error)
        alert("提交失败")
    })
}
export default auth